import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import getMenuItems from '../helpers/getMenuItems';

import styles from '../styles/segmentedButton.module.scss';

const SegmentedButton = ({ isDisabled = false, primaryAction, secondaryActions }) => (
  <div className={styles.element}>
    <Button
      className={styles.hasSquareEnd}
      color="brand"
      icon={primaryAction.icon}
      isDisabled={isDisabled || primaryAction.isDisabled}
      onClick={primaryAction.onClick}
      size="small"
      text={i18n.t(primaryAction.key)}
      to={primaryAction.route}
    />
    <span className={classnames(styles.divider, isDisabled && styles.isDisabled)} />
    <Menu
      component={
        <Button
          className={styles.hasSquareStart}
          color="brand"
          icon={<KeyboardArrowDown sx={{ height: 18, width: 18 }} />}
          isDisabled={isDisabled}
          size="small"
        />
      }
      contentClassName={styles.menu}
    >
      {getMenuItems(secondaryActions)}
    </Menu>
  </div>
);

SegmentedButton.actionPropType = PropTypes.shape({
  icon: PropTypes.string,
  isDisabled: PropTypes.bool,
  isLink: PropTypes.bool,
  key: PropTypes.string,
  onClick: PropTypes.func,
  route: PropTypes.string,
});

SegmentedButton.propTypes = {
  isDisabled: PropTypes.bool,
  primaryAction: SegmentedButton.actionPropType.isRequired,
  secondaryActions: PropTypes.arrayOf(SegmentedButton.actionPropType).isRequired,
};

export default React.memo(SegmentedButton);
